import { rpcHttpKey } from "@uicomps/common/helpers";
import { reactive, ref } from "vue";
import { i18n } from "@overlay/plugins/i18n";

export enum EmailCodeType {
  PasswordReset,
  EmailVerification,
}
export async function isCodeValid(
  email: string,
  code: string,
  codeType?: EmailCodeType,
) {
  return await rpcHttpKey("UserIsCodeValid", {
    email,
    code,
    codeType,
  });
}
export async function isReferralCodeValid(
  code: string,
): Promise<boolean | null> {
  return await isCodeValid(signupData.email, code);
}
export const signupDataDirty = reactive({
  email: ref(""),
  referralCode: ref(""),
});
export const signupData = reactive({
  selectedCharacter: ref("0xDEF"),
  username: ref(""),
  email: ref(""),
  password: ref(""),
  referralCode: ref(""),
  emailVerificationCode: ref(""),
});
export function getFormattedSignupData() {
  const data = JSON.parse(JSON.stringify(signupData));
  data.referralCode =
    new URLSearchParams(window.location.search).get("campaign") ||
    data.referralCode.toString().toLowerCase();
  data.campaign = new URLSearchParams(window.location.search).get("campaign");
  data.locale = i18n.global.locale.value;
  console.log({ data });
  return data;
}
export const signedUpUserId = ref("");

export const carouselAddresses = [
  "0xDEF",
  "0xDEFFemaleA",
  "0xDEFMaleA",
  "0xDEFFemaleB",
  "0xDEFMaleB",
  "0xDEFFemaleC",
  "0xDEFMaleC",
  "0x98F846D92D3f36723E8c35e2fF437130281D9bD5",
];

export const unavailableCarouselAddresses = [
  "0x98F846D92D3f36723E8c35e2fF437130281D9bD5",
];

export function isCharacterAvailable(characterAddress: string): boolean {
  return !unavailableCarouselAddresses.includes(characterAddress);
}
